import { useTheme } from 'styled-components/native'

export const useMediaQuerySize = () => {
  const { breakpoints } = useTheme()
  return breakpoints
}
